export default "__VITE_ASSET__BZXM33T$__"